import React from "react";
import Home from "./Components/Home";
import About from "./Components/About";
import Skills from "./Components/Skills";
import Experience from "./Components/Experience";
import Projects from "./Components/Projects";
import Contact from "./Components/Contact";
import Navbar from "./Components/Navbar";
import BackgroundEffects from "./Components/BackgroundEffects";
import Footer from "./Components/Footer";
import ScrollLine from "./Components/ScrollLine";

function App() {
  return (
    <div className="min-h-screen bg-[#08080c] text-white">
      <BackgroundEffects />
      <ScrollLine />

      <Navbar />

      <main>
        <Home />
        <About />
        <Skills />
        <Experience />
        <Projects />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;
